import { ExamCommentsTab } from 'common/Jacket/ExamCommentsTab';
import { Stack } from 'common/ui/Layout';
import { useExamCommentsQuery } from 'common/ExamComment/useExamCommentsQuery';
import { useMemo } from 'react';
import { Colors } from 'styles/index';
import Text from 'common/ui/Text';
import { telemetryContextFor } from 'modules/Apollo/types';
import { rootTheme } from 'theme/rootTheme';

const COMMENT_SECTION_HEIGHT = 250;

export const ExamCommentsModalSection = ({
  smid,
  onChangeComment,
}: {
  smid?: string;
  onChangeComment?: (comment: string) => void;
}) => {
  const { data, loading } = useExamCommentsQuery(smid ?? '', {
    fetchPolicy: 'cache-and-network',
    context: COMMENT_SECTION_APOLLO_QUERY_CONTEXT,
  });
  const comments = useMemo(
    () => (data?.examComments ?? []).filter((c) => c != null),
    [data?.examComments]
  );

  return (
    <Stack
      vertical
      css={`
        border-top: 1px solid ${Colors.gray6}70;
        padding: 12px 0px;
      `}
      space="medium"
    >
      <Text variant="display1">Comments</Text>
      <div
        css={`
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          width: 100%;
          max-height: ${COMMENT_SECTION_HEIGHT}px;
          background-color: ${Colors.gray3};
          border-radius: ${rootTheme.radius.md}px;
          box-sizing: border-box;
        `}
      >
        <ExamCommentsTab
          heightPx={COMMENT_SECTION_HEIGHT}
          comments={comments}
          loading={loading}
          worklistItemSmid={smid ?? ''}
          onChangeComment={onChangeComment}
          showSendButton={false}
        />
      </div>
    </Stack>
  );
};

ExamCommentsModalSection.displayName = 'ExamCommentsModalSection';

const COMMENT_SECTION_APOLLO_QUERY_CONTEXT = telemetryContextFor(ExamCommentsModalSection);
